module.exports = __webpack_public_path__ + "media/images/user-input-7a24023b1075170bbab83e1e81e69ffc3636cf54bf71b90272cef74a497eb067.svg";